import { render, staticRenderFns } from "./BadgesCard.vue?vue&type=template&id=12ae9764&scoped=true"
import script from "./BadgesCard.vue?vue&type=script&lang=js"
export * from "./BadgesCard.vue?vue&type=script&lang=js"
import style0 from "./BadgesCard.vue?vue&type=style&index=0&id=12ae9764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae9764",
  null
  
)

export default component.exports